import React, { useState, useEffect, useRef } from "react";
import editIcon from "assets/themeIcons/edit-icon.svg";
import { useAppServices } from "hook/services";
import toast from "react-hot-toast";
import { uploadImageToGhl } from "hook/services";
import Quill from "quill";
import "quill/dist/quill.snow.css";

const Blogs = ({ data, onLoad, agency }) => {
  const currentItems = data || [];
  const AppService = useAppServices();

  const [selectedBlog, setSelectedBlog] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [imageUploading, setImageUploading] = useState(false);
  const quillRef = useRef(null);
  const quillInstance = useRef(null);

  const handleOpenModal = (blog) => {
    setSelectedBlog(blog);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setSelectedBlog(null);
    setIsModalOpen(false);
  };

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setImageUploading(true);
    try {
      const imageResponse = await uploadImageToGhl(file, agency);
      if (imageResponse?.data) {
        setSelectedBlog({ ...selectedBlog, image: imageResponse.data });
        toast.success("Image uploaded successfully!");
      }
    } catch (err) {
      toast.error("Failed to upload image");
    } finally {
      setImageUploading(false);
    }
  };

  const handleSave = async () => {
    try {
      setLoading(true);

      const descriptionHTML = quillInstance.current.root.innerHTML;

      const payload = {
        _id: selectedBlog?._id,
        title: selectedBlog?.title,
        description: descriptionHTML,
        image: selectedBlog?.image || "",
      };

      await AppService.blogs.Update({ payload });

      handleCloseModal();
      onLoad();
      toast.success("Blog updated successfully!");
    } catch (err) {
      toast.error("Error updating blog");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isModalOpen) {
      setTimeout(() => {
        if (quillRef.current && !quillInstance.current) {
          quillInstance.current = new Quill(quillRef.current, {
            theme: "snow",
            placeholder: "Write blog content...",
          });
        }
        if (selectedBlog && quillInstance.current) {
          quillInstance.current.root.innerHTML = selectedBlog.description || "";
        }
      }, 100);
    }

    return () => {
      if (!isModalOpen && quillInstance.current) {
        quillInstance.current = null;
      }
    };
  }, [isModalOpen]);

  const tableTHStyles = {
    fontFamily: "Poppins",
    fontWeight: 600,
  };

  return (
    <>
      <div style={{ width: "100%", overflowX: "auto" }}>
        <table
          className="table"
          style={{
            width: "100%",
            borderCollapse: "collapse",
            minWidth: "1200px",
          }}
        >
          <thead>
            <tr style={{ background: "#F7F7F7", borderRadius: "18px" }}>
              <th className="p-20-px" style={tableTHStyles}>Image</th>
              <th className="p-20-px" style={tableTHStyles}>Title</th>
              <th className="p-20-px" style={tableTHStyles}>Business</th>
              <th className="p-20-px" style={tableTHStyles}>Description</th>
              <th className="p-20-px" style={tableTHStyles}>Date</th>
              <th className="p-20-px" style={tableTHStyles}>Edit</th>
            </tr>
          </thead>

          <tbody>
            {currentItems?.length > 0 ? (
              currentItems.map((item, index) => (
                <tr key={index}>
                  <td className="p-20-px">
                    {item?.image ? (
                      <img
                        src={item.image}
                        alt="blog"
                        style={{ width: 60, height: 60, borderRadius: 6, objectFit: "cover" }}
                      />
                    ) : (
                      "-"
                    )}
                  </td>

                  <td className="p-20-px">{item?.title}</td>

                  <td className="p-20-px">{item?.account_id?.first_name}</td>

                  <td className="p-20-px">
                    <div dangerouslySetInnerHTML={{ __html: item?.description }} />
                  </td>

                  <td className="p-20-px">
                    {new Date(item?.createdAt).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })}
                  </td>

                  <td className="p-20-px">
                    <img
                      onClick={() => handleOpenModal(item)}
                      width={20}
                      src={editIcon}
                      style={{ cursor: "pointer" }}
                    />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={6} className="text-center">
                  No blogs found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {isModalOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: "10px",
              padding: "30px",
              width: "600px",
              maxWidth: "90%",
              boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
            }}
          >
            <h3>Edit Blog</h3>

            <label style={labelStyle}>Title</label>
            <input
              type="text"
              value={selectedBlog?.title || ""}
              onChange={(e) => setSelectedBlog({ ...selectedBlog, title: e.target.value })}
              style={inputStyle}
            />

            <label style={labelStyle}>Description</label>
            <div
              ref={quillRef}
              style={{
                height: "200px",
                border: "1px solid #ccc",
                borderRadius: "8px",
                marginTop: "10px",
              }}
            ></div>

            <label style={labelStyle}>Image</label>
            <input type="file" accept="image/*" onChange={handleImageChange} />

            <div style={buttonRow}>
              <button onClick={handleCloseModal} style={cancelBtn}>Cancel</button>
              <button
                onClick={handleSave}
                disabled={loading || imageUploading}
                style={saveBtn}
              >
                {loading || imageUploading ? "Saving..." : "Save"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// Styles
const inputStyle = {
  width: "100%",
  padding: "10px",
  marginTop: "8px",
  borderRadius: "8px",
  border: "1px solid #ddd",
};

const labelStyle = {
  fontWeight: 600,
  marginTop: "20px",
  display: "block",
};

const buttonRow = {
  display: "flex",
  justifyContent: "flex-end",
  gap: "10px",
  marginTop: "25px",
};

const cancelBtn = {
  padding: "8px 16px",
  background: "#ccc",
  border: "none",
  borderRadius: "8px",
  cursor: "pointer",
};

const saveBtn = {
  padding: "8px 16px",
  background: "#007bff",
  color: "#fff",
  border: "none",
  borderRadius: "8px",
  cursor: "pointer",
};

export default Blogs;
